import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { changeStatus } from "../actions/currency";
import toast from "react-hot-toast";

function SubscriptionCard({ data }) {
  const history = useHistory();
  const [checkStatus, setCheckedStatus] = useState();

  useEffect(() => {
    setCheckedStatus(data.planStatus);
    console.log("SubscriptionCard", data);

  }, []);

  const changePlan = async (e) => {
    let { status, message } = await changeStatus({
      _id: data._id,
      status: e.target.checked,
    });
    if (status) {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };

  return (
    <>
      <div className="subscription_card rounded-3">
        <div
          className={` p-3 rounded-2 ${data.fee <= 10
              ? "subscription_card_blueHead position-relative"
              : "subscription_card_greenHead position-relative"
            }`}
        >
          <p className="subsciption_title text-center">
            {data?.name}

            <button
              className="cmn_plain_btn"
              onClick={(e) => {
                //  let stateData = {...data}
                history.push({
                  pathname: "/editsubscription",
                  state: { datas: JSON.stringify(data) },
                });
              }}
            >
              <img
                src={require("../assets/images/editer.svg").default}
                className="img-fluid table_activity_img"
              />{" "}
            </button>
          </p>

          <Form.Check
            type="switch"
            className="remove_toggleBtn"
            checked={checkStatus}
            onClick={(e) => {
              changePlan(e);
              setCheckedStatus(e.target.checked);
            }}
          />
        </div>
        <div className="subscriptioc_card_body py-3 px-4 ">
          <p className="subsciption_price_days text-center mb-3">
            ${data.fee}/
            <small>
              {data.duration}
              {data.validity}
            </small>
          </p>
          <div className="d-flex flex-column align-items-center">
            <ul>
              {data?.highlights.map((item) => (
                <li className="mb-2 d-flex gap-2">
                  <img
                    src={
                      data?.fee <= 10
                        ? data?.blueCheck?.default
                        : data?.greenCheck?.default
                    }
                    className="img-fluid subscript_checkers"
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          {/* <button
            className={`subsciption_green_gradBtn w-100 rounded-2 mt-4 ${
              data.price <= 10
                ? "subsciption_blue_gradBtn"
                : "subsciption_green_gradBtn"
            }`}>
            Learn more
          </button> */}
        </div>
      </div>
    </>
  );
}

export default SubscriptionCard;
